export const webEmbedTab = {
  scope: {
    title: "Cosa deve cercare il tuo sito?",
    only: "Solo",
    thisListing: "questo annuncio",
    hint: "Consigliato se incolli il codice nella pagina di questo alloggio. Disattivalo per far sì che la ricerca mostri tutti i tuoi alloggi.",
  },
  where: {
    title: "Dove devono comparire gli alloggi?",
    hint: 'La barra di ricerca è identica in tutti e tre i casi. Ciò che cambia è cosa succede quando il visitatore tocca "Cerca".',
    ariaLabel: "Dove compare la disponibilità",
    ownFields: {
      name: "Ho già la mia barra di ricerca",
      hint: "Non aggiungeremo la nostra barra: usa i tuoi campi e passaci la ricerca",
    },
  },
  modes: {
    overlay: {
      name: "Fluttuante sul tuo sito",
      tag: "Consigliato",
      desc: "L'elenco si apre in una finestra sopra la tua pagina e si chiude con la X. Il tuo sito non si muove: il visitatore torna esattamente dov'era.",
    },
    inline: {
      name: "All'interno della tua pagina",
      desc: "L'elenco compare sul tuo sito, come un'altra sezione: scorre insieme al resto dei contenuti e non c'è nulla da chiudere. Scegli tu dove mostrarlo nella pagina.",
    },
    tab: {
      name: "In una nuova scheda",
      desc: "La barra risiede sul tuo sito e, al momento della ricerca, la prenotazione prosegue in un'altra scheda. È l'opzione più semplice, ma il visitatore completa la prenotazione altrove.",
    },
  },
  modeNote: {
    overlay: "La barra di ricerca mantiene un'altezza fissa e non cambia: l'elenco e l'intero processo di prenotazione avvengono nella finestra fluttuante, con il proprio scorrimento.",
    inline: "Qui l'unica cosa che si espande è la sezione dell'elenco, cioè esattamente ciò che hai chiesto di espandere. La barra di ricerca occupa sempre lo stesso spazio e il calendario si apre sopra di essa, senza spostare nulla.",
    tab: "Viene incorporata solo la barra. Tutto il resto avviene nel motore di prenotazione, in una scheda separata.",
  },
  webs: {
    bahia: "Sito con hero",
    cala: "Sito minimalista",
  },
  fondos: {
    white: "Bianco (predefinito)",
    transparent: "Trasparente · adotta quello del tuo sito",
  },
  appearance: {
    title: "Aspetto",
    buttonColor: "Colore del pulsante",
    background: "Sfondo della barra di ricerca",
    language: "Lingua",
  },
  preview: {
    title: "Come appare su un sito web",
    hint: "Un sito di esempio con la tua barra di ricerca già inserita. È il widget reale: scegli le date e tocca Cerca per vedere come si comporta.",
    openFull: "Apri a dimensione intera",
    testIn: "Prova su",
    testInAriaLabel: "Sito web di esempio",
    missingUuid: "Manca l'identificatore dell'account per generare il widget.",
    fakeUrl: "your-site.com",
    iframeTitle: "Anteprima del widget su un sito web di esempio",
  },
  guide: {
    title: "Come aggiungerlo al tuo sito",
    hint: 'Funziona su qualsiasi pagina: HTML, WordPress (blocco "Custom HTML"), Wix, Squarespace, Shopify… Niente da installare.',
    warn: "<b>Se il tuo sito è Wix, Squarespace o Shopify</b>, due cose: nell'<b>editor</b> il blocco di codice sembra sempre vuoto —funziona solo in \"Anteprima\" o una volta pubblicato—, e poiché queste piattaforme racchiudono la barra di ricerca in un riquadro tutto loro, <b>tutto avviene dentro quel riquadro</b>: il calendario e l'elenco degli alloggi. Quindi <b>allungalo fino a circa 900 px di altezza</b> nell'editor; se è troppo corto, il calendario viene tagliato. Al resto pensiamo noi: non modificare il codice.",
    missingUuid: "Manca l'identificatore dell'account per generare il codice.",
    copy: "Copia",
    copied: "Copiato",
    saveReload: "Salva e ricarica il tuo sito",
  },
  steps: {
    script: {
      title: "Incolla questo dove vuoi che compaia la barra di ricerca",
      titleOwn: "Incolla questo una sola volta, in qualsiasi punto della pagina",
      hint: "Proprio dove vuoi la barra delle date: l'hero, una striscia sotto il menu, una barra laterale…",
      hintOwn: "Da solo non disegna nulla: prepara la prenotazione per il tuo modulo.",
      after: "La barra mantiene un'altezza fissa e non si ridimensiona, quindi non altererà il tuo layout.",
    },
    target: {
      title: "Incolla questo spazio dove vuoi che compaia l'elenco",
      hint: 'Di solito una sezione a sé sotto l\'hero, con il tuo titolo sopra ("Disponibilità", "Le nostre case"…).',
      after: "Finché nessuno cerca, quello spazio non occupa posto. Se lo ometti, l'elenco compare subito sotto la barra di ricerca.",
    },
    api: {
      title: "Collega i tuoi campi alla ricerca",
      hint: "Mantieni il tuo design, ma il calendario può essere il nostro: quello che mostra il prezzo di ogni notte, il soggiorno minimo e i giorni già prenotati.",
      after: "Se preferisci i tuoi campi data, va bene lo stesso: passaci le date in formato YYYY-MM-DD direttamente a WACheckin.search().",
    },
  },
  toasts: {
    manualCopySummary: "Copia manuale",
    manualCopyDetail: "Il tuo browser non ha consentito la copia automatica. Il codice è già selezionato.",
  },
};
